import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const SeatingCapacity = (props) => {
  return (
    <FormGroup controlId="seatingCap">
      <Col componentClass={ControlLabel} sm={5}>
        Seating Capacity (excluding Driver)
      </Col>
    <Col sm={7}>
        <FormControl type="text" value={props.seatingCap}
          onChange={props.handleChangeSeatingCap} autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

SeatingCapacity.propTypes = {
  seatingCap: PropTypes.number,
  handleChangeSeatingCap: PropTypes.func
};

export default SeatingCapacity;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/seatingCapacity/SeatingCapacity.js